export const getBotName = (bot) =>
  bot?.data?.webchat_settings?.bot_name ||
  bot?.data?.name ||
  "AI assistant";

export const getAvatarAlt = ({ bot, operators, author }) => {
  if (author === "Me") {
    return "Your profile photo";
  }

  if (!isNaN(author)) {
    const operator = operators?.data?.find(
      (el) => String(el.id) === String(author),
    );
    const operatorName = operator
      ? `${operator.first_name || ""} ${operator.last_name || ""}`.trim()
      : "team member";
    return `Photo of ${operatorName}, team member`;
  }

  return `Photo of ${getBotName(bot)}, AI assistant`;
};

export const getBotAvatarAlt = (bot) =>
  `Photo of ${getBotName(bot)}, AI assistant`;
